import i18n from 'modules/core/lib/i18n'
import formatCurrency from 'modules/core/lib/formatCurrency'
import { toCents } from 'modules/core/lib/formatCurrencyUtils'

export const formatPrice = (
  cost: number | string | null | undefined,
  period: number | null | undefined
): string => {
  if (!cost) return '-'
  const costNumber = typeof cost === 'string' ? parseFloat(cost) : cost
  if (isNaN(costNumber)) return '-'
  const formattedCost = formatCurrency(toCents(costNumber))

  if (period && period > 0) {
    return `${i18n.t('it_management.device_catalog.detail.from_label')} ${i18n.t(
      'it_management.device_catalog.detail.from_price_per_month',
      { amount: formattedCost }
    )}`
  }
  return formattedCost
}

export const formatPeriod = (period: number | null | undefined): string | undefined => {
  if (!period || period <= 0) return undefined
  return i18n.t('it_management.device_catalog.detail.period_months', { count: period })
}
